/**
 * Unit conversions for production files.
 *
 * Production SVGs are exported with width/height taken from the design's
 * Anchor object, whose units are PostScript points (the design pipeline's
 * px→cm convention divides by 28.3464567 pt/cm).
 */
export const PT_PER_CM = 28.3464567;
export const PT_PER_INCH = 72;
export const PT_PER_MM = PT_PER_CM / 10;

export function cmToPt(cm: number): number {
  return cm * PT_PER_CM;
}

export function ptToCm(pt: number): number {
  return pt / PT_PER_CM;
}

/** Factory nesting options (paper size, piece padding) are entered in inches. */
export function inchToPt(inches: number): number {
  return inches * PT_PER_INCH;
}

export function ptToInch(pt: number): number {
  return pt / PT_PER_INCH;
}

/** Laser-cutting outline specs (band widths, offsets) are millimetres. */
export function mmToPt(mm: number): number {
  return mm * PT_PER_MM;
}
